// Initiales pour l'avatar fallback (ex. "Marie-Ange Desnoyers" → "MD").
// Fonction PURE, sans dépendance serveur : utilisable côté client (l'avatar est
// rendu dans des composants client comme la carte membre admin).
export function getInitials(fullName: string | null, email: string): string {
  const source = fullName?.trim() || email.split('@')[0]
  const parts = source.split(/[\s-]+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}
